// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1qbY3","question":"Question_question__1aieq","description":"Question_description__2kw_O"};